import React from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../../components/ui/dialog';

export const DeleteTemplateDialog = ({ open, onOpenChange, template, deleting, onDelete }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-red-600">
          <Trash2 className="h-5 w-5" />
          Delete Template
        </DialogTitle>
        <DialogDescription className="sr-only">Delete Template dialog. Use the form below to continue.</DialogDescription>
      </DialogHeader>
      <p className="text-sm text-gray-600">
        Are you sure you want to delete <strong>{template?.title}</strong>?
      </p>
      <p className="text-xs text-gray-400">
        If this template has been published to clients, it will be archived instead of deleted to preserve document history.
      </p>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button variant="destructive" onClick={onDelete} disabled={deleting} data-testid="confirm-delete-btn">
          {deleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
